import * as React from 'react';
import StarIcon from './StarIcon';

type StarProps = {
  isFilled: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onSubmit: () => void;
};

const Star: React.FC<StarProps> = ({ isFilled, onMouseEnter, onMouseLeave, onSubmit, ...rest }: StarProps) => {
  return (
    <span
      className="ml-4 mr-3 cursor-pointer"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onSubmit}
      onKeyDown={onSubmit}
      data-testid="star-rating-star-container"
    >
      <StarIcon
        fill={isFilled ? 'var(--ex3d-star-rating-color)' : 'none'}
        stroke={isFilled ? 'none' : 'black'}
        {...rest}
      />
    </span>
  );
};

export default Star;
